import { useEffect, useState } from 'react';
import { Button, Item, Label } from 'semantic-ui-react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';

const HomeOfTheWeekListing = ({ getHotwListingById, listings, listingId, removeItem, moveUp, moveDown }) => {
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    if (!listingId) return;
    getHotwListingById(listingId);
  }, [listingId]);

  useEffect(() => {
    if (listings && listings[listingId]) {
      setCurrent(listings[listingId]);
    }
  }, [listings]);

  const getContent = () => (
    <Item>
      <Item.Image size="small" src={current.imageUrl} />

      <Item.Content>
        <Item.Header as="a" href={current.url} target="_blank">
          {current.description1}
        </Item.Header>
        <Item.Extra>{current.description2}</Item.Extra>
        <Item.Extra>
          {current.address} {current.city}, {current.state}
        </Item.Extra>

        <Item.Extra style={{ marginTop: 0 }}>
          <Label>
            Date Created
            <Label.Detail>{moment(current.dateCreated).format('LLL')}</Label.Detail>
          </Label>

          <Label>
            Firm
            <Label.Detail>{current?.firm?.name}</Label.Detail>
          </Label>

          <Button basic icon="trash" size="mini" floated="right" negative onClick={() => removeItem(current)} />
          <Button basic icon="arrow up" size="mini" floated="right" onClick={moveUp} />
          <Button basic icon="arrow down" size="mini" floated="right" onClick={moveDown} />
        </Item.Extra>
      </Item.Content>
    </Item>
  );

  return <>{current?.id && getContent()}</>;
};

const mapStateToProps = state => ({
  listings: selectors.getCampaignListings(state),
});

const mapDispatchToProps = dispatch => ({
  getHotwListingById: bindActionCreators(actions.campaign.getHotwListingById, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeOfTheWeekListing);
